export const parseIntegrationFunctionId = (id: string) => {
  const separatorIndex = id.indexOf('__');

  if (separatorIndex === -1) {
    return {
      providerId: id,
      functionName: id,
    };
  }

  const providerId = id.slice(0, separatorIndex);
  const functionName = id;

  return {
    providerId,
    functionName,
  };
};
